module.exports = __webpack_public_path__ + "static/img/apply4.4cc69f83.png";